
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(30),
  distributorId: Number.withConstraint(x => x >= 0),
  versionDate: Number.withConstraint(x => x >= 1230764400),
  websiteId: String,
  accountHash: String.withConstraint(x => x.length <= 32),
  referrer: String.withConstraint(x => x.length <= 255),
  event_mapping_version: Literal(2),
}).And(Partial({
  event_mapping_version: Number.withConstraint(x => x >= 1 && x <= 10),
  sub_partner_id: Number.withConstraint(x => x >= 0),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(30),
  distributorId: Number.withConstraint(x => x >= 0),
  versionDate: Number.withConstraint(x => x >= 1230764400),
  websiteId: String,
  accountHash: String.withConstraint(x => x.length <= 32),
  referrer: String.withConstraint(x => x.length <= 255),
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  lang: String.withConstraint(x => x.length <= 5),
}).And(Partial({
  event_mapping_version: Number.withConstraint(x => x >= 1 && x <= 10),
  sub_partner_id: Number.withConstraint(x => x >= 0),
  zoneId: Number.withConstraint(x => x >= 0 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 30;
  